import Layout from "../../layout";
import "./faqs.css";
import Input from "antd/lib/input";
import Collapse from "antd/lib/collapse";
import { IoSearchSharp } from "react-icons/io5";
import { IoIosArrowDown } from "react-icons/io";
import { IoIosArrowUp } from "react-icons/io";
import useFaq from "../../hooks/use_faq";
import { useEffect } from "react";
import Skeleton from "../../components/skeleton";
import { useSelector } from "react-redux";

const { Panel } = Collapse;

const FAQs = () => {
  const {
    // entity methods
    getFaqList,
    // entity states
    faqList,
    filteredFAQ,
    setFilteredFAQ,
    // controller states
    faqQuery,
    setFaqQuery,
    // loading states
    loadings,
  } = useFaq();

  const userProfile = useSelector((state) => state.app.userProfile);

  useEffect(() => {
    if (userProfile) {
      getFaqList();
    }
  }, [userProfile]);

  return (
    <Layout>
      <div className="faqs">
        <h3>FAQs</h3>
        {/* search */}
        <div className="search">
          <Input
            value={faqQuery}
            onChange={(e) => {
              setFaqQuery(e.target.value);
              setFilteredFAQ(
                faqList?.filter((o) =>
                  o.question
                    .toLowerCase()
                    .replace(/[\u0300-\u036f]/g, "")
                    .includes(
                      e.target.value
                        .toLowerCase()
                        .replace(/[\u0300-\u036f]/g, "")
                    )
                )
              );
            }}
            placeholder="Search in questions"
          />
          <IoSearchSharp />
        </div>

        <div className="collapse_container">
          {loadings.getFaqList
            ? Array(5)
                .fill()
                .map((item, index) => (
                  <Skeleton
                    key={index}
                    style={{
                      width: "100%",
                      height: 55,
                      borderRadius: 8,
                      marginBottom: 18,
                    }}
                  />
                ))
            : filteredFAQ?.length > 0
            ? filteredFAQ.map((item, index) => (
                <Collapse
                  key={index}
                  className="custom_collapse"
                  bordered={false}
                  expandIconPosition="end"
                  expandIcon={({ isActive }) =>
                    isActive ? (
                      <IoIosArrowUp
                        style={{ color: "var(--second)", fontSize: "16px" }}
                      />
                    ) : (
                      <IoIosArrowDown
                        style={{ color: "var(--second)", fontSize: "16px" }}
                      />
                    )
                  }
                >
                  <Panel
                    header={
                      <div className="label_collapse">{item.question}</div>
                    }
                    key={item.id}
                    className="custom_panel"
                    showArrow={true}
                  >
                    <div className="content_faqs">{item.answer}</div>
                  </Panel>
                </Collapse>
              ))
            : faqList.map((item, index) => (
                <Collapse
                  key={index}
                  className="custom_collapse"
                  bordered={false}
                  expandIconPosition="end"
                  expandIcon={({ isActive }) =>
                    isActive ? (
                      <IoIosArrowUp
                        style={{ color: "var(--second)", fontSize: "16px" }}
                      />
                    ) : (
                      <IoIosArrowDown
                        style={{ color: "var(--second)", fontSize: "16px" }}
                      />
                    )
                  }
                >
                  <Panel
                    header={
                      <div className="label_collapse">{item.question}</div>
                    }
                    key={item.id}
                    className="custom_panel"
                    showArrow={true}
                  >
                    <div className="content_faqs">{item.answer}</div>
                  </Panel>
                </Collapse>
              ))}
        </div>
      </div>
    </Layout>
  );
};

export default FAQs;
